import {StickyNoteData, Widget} from '@dv5/domain'
import React, {FC, useMemo} from 'react'
import {ColorPicker} from '../common/ColorPicker'
import {FontStylePicker} from '../sticky-note/FontStylePicker'
import {COLOR_PRESETS} from '../sticky-note/constants'
import {WidgetDataChange, canvasWidgetsDataService} from '../../services/canvasWidgetsDataService'

interface Props {
    canvasId: string
    widgets: Widget[]
}

export const StickyNotePropertiesPanel: FC<Props> = ({
    canvasId,
    widgets,
}) => {
    const bgColorMixed = useMemo(
        () => new Set(widgets.map(w => (w.data as StickyNoteData).bgColor)).size > 1,
        [widgets],
    )
    const fontStyleMixed = useMemo(
        () => new Set(widgets.map(w => (w.data as StickyNoteData).fontStyle)).size > 1,
        [widgets],
    )
    const bgColor = widgets.length > 0 && !bgColorMixed ? (widgets[0].data as StickyNoteData).bgColor : ''
    const fontStyle = widgets.length > 0 && !fontStyleMixed ? (widgets[0].data as StickyNoteData).fontStyle : ''

    const applyPatch = (patchedPaths: Array<string>, patch: Partial<StickyNoteData>) => {
        const changes: Array<WidgetDataChange> = widgets.map(widget => ({
            widgetId: widget.id,
            patchedPaths,
            data: {...(widget.data as StickyNoteData), ...patch},
        }))
        canvasWidgetsDataService.changeWidgetsData(canvasId, changes)
    }

    const handleColorChange = (color: string) => {
        applyPatch(['bgColor'], {bgColor: color})
    }

    const handleFontStyleChange = (style: string) => {
        applyPatch(['fontStyle'], {fontStyle: style})
    }

    return (
        <div
            className='align-widgets-bar__properties'
            onMouseDown={e => e.stopPropagation()}
        >
            <ColorPicker
                value={bgColor}
                presets={COLOR_PRESETS}
                onChange={handleColorChange}
                mixed={bgColorMixed}
            />
            <FontStylePicker
                prefix="align-widgets-bar"
                value={fontStyle}
                onChange={handleFontStyleChange}
            />
        </div>
    )
}
